import { Record } from 'immutable';
import { ATTEMPT, FAILURE, SUCCESS } from './actions';

export const InitialState = new Record({
  slipId: ''
});

export default (state = new InitialState(), action) => {
  switch (action.type) {
    case ATTEMPT: {
      return state
        .set('slipId', action.slipId);
    }
    case SUCCESS:
    case FAILURE: {
      return state
        .set('slipId', '');
    }
    default: {
      return state;
    }
  }
};
